import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { variables } from '../../styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      backgroundColor: variables.white,
      justifyContent: 'space-between',
    },
    container: {
      display: 'flex',
      flexWrap: 'wrap',
      width: 598,
      padding: '50px 60px',
      minHeight: 557,
      margin: `${theme.spacing(0)} auto`,

      '@media (max-width: 600px)': {
        width: '100%',
      },
    },
    required: {
      color: variables.red,
    },
    card: {
      boxShadow: 'none',
    },
    padding: {
      paddingTop: 30,
    },
    label: {
      fontSize: 14,
      fontWeight: 500,
      color: variables.policeBlue,
    },
    cardActions: {
      marginTop: 30,
      marginBottom: 40,
      justifyContent: 'center',
    },
    title: {
      fontWeight: 700,
      fontSize: 28,
      textAlign: 'center',
      color: variables.black,
    },
    input: {
      '& .MuiOutlinedInput-input': {
        fontSize: 14,
        color: variables.policeBlue,
      },
      '& .MuiOutlinedInput-root': {
        borderRadius: 4,
        height: 40,
      },
    },
    disabledInput: {
      backgroundColor: variables.ghostWhite,
      '& .MuiOutlinedInput-input': {
        color: variables.shadowBlue,
      },
      '& .MuiOutlinedInput-root': {
        borderRadius: 4,
        height: 40,
      },
    },
    icon: {
      color: variables.policeBlue,
    },
    disabledIcon: {
      color: variables.shadowBlue,
    },
    submitButton: {
      borderRadius: 4,
      height: 46,

      '&:hover': {
        backgroundColor: variables.cobaltBlue,
        color: variables.white,
      },
    },
    checkIcon: {
      fontSize: 98,
      color: '#2CC67C',
    },
    successCard: {
      boxShadow: 'none',
      textAlign: 'center',
    },
    successAction: {
      justifyContent: 'center',
    },
    margin: {
      marginTop: 40,
      marginBottom: 40,
    },
  }),
);
